module.exports = __webpack_public_path__ + "img/header-diamondJewelryBestseller@2x.ab61052.jpg";